import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgUserMultiple = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.128 4.39a3.43 3.43 0 0 1 2.001-.64 3.425 3.425 0 0 1 3.434 3.417 3.42 3.42 0 0 1-2.961 3.384.75.75 0 1 1-.204-1.486 1.92 1.92 0 0 0 1.665-1.898A1.925 1.925 0 0 0 14.13 5.25c-.423 0-.812.134-1.13.36a.75.75 0 1 1-.871-1.22M9.655 7.028a1.925 1.925 0 0 0-1.934 1.916c0 1.054.862 1.917 1.934 1.917a1.925 1.925 0 0 0 1.935-1.917 1.925 1.925 0 0 0-1.935-1.916M6.221 8.944a3.425 3.425 0 0 1 3.434-3.416 3.425 3.425 0 0 1 3.435 3.416 3.425 3.425 0 0 1-3.435 3.417 3.425 3.425 0 0 1-3.434-3.417m8.246 3.26q.033-.003.066 0c3.82.165 5.507 2.653 6.175 4.194.236.544.14 1.113-.175 1.532-.307.408-.801.653-1.34.653h-1.485a.75.75 0 0 1 0-1.5h1.485c.085 0 .128-.036.14-.054l.006-.009a.1.1 0 0 0-.008-.025c-.539-1.245-1.826-3.148-4.831-3.292-.481.023-.914.09-1.303.19a.75.75 0 1 1-.372-1.453 8 8 0 0 1 1.642-.237m-4.812 3.268c-3.277 0-4.643 2.01-5.201 3.3a.1.1 0 0 0-.008.025q0 .003.005.01c.013.018.056.054.14.054H14.72c.084 0 .127-.037.14-.054l.006-.01a.1.1 0 0 0-.008-.026c-.558-1.288-1.924-3.299-5.202-3.299m-6.578 2.703c.694-1.6 2.481-4.203 6.578-4.203s5.885 2.603 6.579 4.203c.235.544.14 1.113-.175 1.532-.306.408-.8.654-1.34.654H4.592c-.54 0-1.035-.246-1.34-.654a1.52 1.52 0 0 1-.175-1.532"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgUserMultiple;
